import { render } from "./AboutSection.vue?vue&type=template&id=18f279af"
const script = {}

import "./AboutSection.vue?vue&type=style&index=0&id=18f279af&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__